import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteClinicCollectionMethod = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (collectionMethodId: string) => {
      return api.delete(`clinic/collection-methods/${collectionMethodId}`);
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "delete-collection-method-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Clinic Collection Method]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });

      handleErrors(res, "mutation");
    },
  });
};
